import React from 'react';
import { Hero } from './components/sections/Hero';
import { BeforeAfterSection } from './components/sections/BeforeAfterSection';
import { OpeningHook } from './components/sections/OpeningHook';
import { ProblemSection } from './components/sections/ProblemSection';
import { WhyFailedSection } from './components/sections/WhyFailedSection';
import { MechanismSection } from './components/sections/MechanismSection';
import { WhatYouGet } from './components/sections/WhatYouGet';
import { BonusStackSection } from './components/sections/BonusStackSection';
import { AudienceFit } from './components/sections/AudienceFit';
import { HowItWorks } from './components/sections/HowItWorks';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { GuaranteeSection } from './components/sections/GuaranteeSection';
import { ProofSection } from './components/sections/ProofSection';
import { FaqSection } from './components/sections/FaqSection';
import { OfferSection } from './components/sections/OfferSection';
import { UrgencySection } from './components/sections/UrgencySection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
import { Footer } from './components/sections/Footer';
import { AnnouncementBar } from './components/ui/AnnouncementBar';
export function App() {
  return <div className="min-h-screen bg-[#0A0E2A] text-white selection:bg-[#C9A84C] selection:text-[#0A0E2A]" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <BeforeAfterSection data-id="element-4" />
        <OpeningHook data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <WhyFailedSection data-id="element-7" />
        <MechanismSection data-id="element-8" />
        <WhatYouGet data-id="element-9" />
        <BonusStackSection data-id="element-10" />
        <AudienceFit data-id="element-11" />
        <HowItWorks data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <ProofSection data-id="element-15" />
        <FaqSection data-id="element-16" />
        <OfferSection data-id="element-17" />
        <UrgencySection data-id="element-18" />
        <FinalCtaSection data-id="element-19" />
      </main>
      <Footer data-id="element-20" />
    </div>;
}